import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Switch, useRouteMatch, useLocation } from "react-router-dom";
import useSpecialTopic from "@sprout/hooks/dist/useSpecialTopic";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { ArrowBackIosOutlined } from "sprout-ui-icons";
import { useGoBack } from "@sprout/providers/dist/goBack";
import { rootPageRoutes } from "@sprout/client-routes";
import { useRouteHistories } from "@sprout/providers/dist/routeHistories";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import AppBarMobile from "../../styles/AppBar_Mobile";
// import AppBarAppMobilePageTitle from "./AppBar_App_Mobile_PageTitle";
const BackButton = styled(Button)`
  margin-left: -12px;
`;
const AppBarAppMobile = ()=>{
    var ref;
    const { goBack  } = useGoBack();
    const rootPageRouteMatch = !!useRouteMatch({
        path: rootPageRoutes,
        exact: true
    });
    const routeHistories = useRouteHistories();
    const { pathname  } = useLocation();
    const currentUser = useCurrentUser();
    const startPage = currentUser === null || currentUser === void 0 ? void 0 : (ref = currentUser.userSetting) === null || ref === void 0 ? void 0 : ref.startPage;
    const { myTasksURL  } = useSpecialTopic();
    return /*#__PURE__*/ _jsxs(AppBarMobile, {
        height: "56px",
        px: "16px",
        id: "AppBarMobile",
        children: [
            routeHistories.length > 1 && !rootPageRouteMatch && // Not `Home`
            pathname !== startPage && // Not `MyTasks`
            pathname !== myTasksURL && /*#__PURE__*/ _jsx(BackButton, {
                variant: "circle",
                onClick: goBack,
                color: "blue.500",
                children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
            }),
            /*#__PURE__*/ _jsx(Switch, {})
        ]
    });
};
export default AppBarAppMobile;
